// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  chip: "TaskField__chip",
  chipMark: "TaskField__chipMark",
  defs: "TaskField__defs",
  dline: "TaskField__dline",
  extra: "TaskField__extra",
  extraOn: "TaskField__extraOn",
  field: "TaskField__field",
  filler: "TaskField__filler",
  fillerField: "TaskField__fillerField",
  fillerFieldDrawn: "TaskField__fillerFieldDrawn",
  fillerFieldOff: "TaskField__fillerFieldOff",
  fillerFieldSettled: "TaskField__fillerFieldSettled",
  fillerUse: "TaskField__fillerUse",
  gline: "TaskField__gline",
  glyph: "TaskField__glyph",
  inkLayer: "TaskField__inkLayer",
  isAug: "TaskField__isAug",
  isAuto: "TaskField__isAuto",
  isDrained: "TaskField__isDrained",
  isFresh: "TaskField__isFresh",
  isHidden: "TaskField__isHidden",
  isIn: "TaskField__isIn",
  isInked: "TaskField__isInked",
  isInst: "TaskField__isInst",
  isPriced: "TaskField__isPriced",
  jobtag: "TaskField__jobtag",
  jobtagOff: "TaskField__jobtagOff",
  label: "TaskField__label",
  labelsOff: "TaskField__labelsOff",
  legend: "TaskField__legend",
  legendItem: "TaskField__legendItem",
  legendOn: "TaskField__legendOn",
  mark: "TaskField__mark",
  paper: "TaskField__paper",
  paperLayer: "TaskField__paperLayer",
  paperOn: "TaskField__paperOn",
  rline: "TaskField__rline",
  root: "TaskField__root",
  sline: "TaskField__sline",
  sq: "TaskField__sq",
  task: "TaskField__task",
  wideField: "TaskField__wideField",
  wideFieldDrawn: "TaskField__wideFieldDrawn",
  wideFieldSettled: "TaskField__wideFieldSettled",
  wrap: "TaskField__wrap",
  wrapGlyph: "TaskField__wrapGlyph",
  wrapZoomed: "TaskField__wrapZoomed",
};
